import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LibraryDetailsContainer = styled(Box)`
  background: ${theme.colors.backgroundDarker};
  border-radius: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const LibraryDetailsScrollArea = styled(Box)`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: ${theme.colors.pageBackground};

  ::-webkit-scrollbar {
    background: transparent !important;
    width: 20px !important;
  }

  ::-webkit-scrollbar-track {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    margin: ${theme.spacing.medium}px 0;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.borderMedium};
    border-radius: 9999px;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-corner {
    background: transparent !important;
  }
`
